var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.33 22.34 5.6 19.61c-1.96-1.32-2.09-1.56-2.09-3.63v-4.96c0-2.07.13-2.31 2.05-3.6l4.78-2.76c.95-.55 2.38-.55 3.33 0l4.73 2.73c1.96 1.32 2.09 1.56 2.09 3.63v4.96c0 2.07-.13 2.31-2.05 3.6l-4.78 2.76c-.47.28-1.07.41-1.66.41-.6 0-1.19-.14-1.67-.41zm.75-16.38L6.35 8.69c-1.34.91-1.34.91-1.34 2.33v4.96c0 1.42 0 1.42 1.39 2.36l4.69 2.7c.48.28 1.35.28 1.83 0l4.73-2.73c1.34-.91 1.34-.91 1.34-2.33v-4.96c0-1.42 0-1.42-1.39-2.36l-4.69-2.7c-.23-.14-.57-.21-.91-.21-.34 0-.68.07-.92.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 7.63V5c0-1.58-.67-2.25-2.25-2.25h-5c-1.58 0-2.25.67-2.25 2.25v2.56a.749.749 0 1 1-1.5 0V5c0-2.42 1.33-3.75 3.75-3.75h5c2.42 0 3.75 1.33 3.75 3.75v2.63c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.98 17.5-.98-.38-.98.39c-.53.21-1.07.16-1.47-.13-.4-.29-.61-.79-.58-1.36l.06-1.05-.67-.81c-.36-.45-.48-.97-.32-1.45.15-.47.56-.83 1.11-.97l1.02-.26.57-.89c.61-.96 1.92-.96 2.53 0l.57.89 1.02.26c.55.14.96.5 1.11.97.15.47.03 1-.33 1.44l-.67.81.06 1.05c.03.57-.18 1.06-.58 1.36-.24.17-.52.26-.82.26-.21 0-.43-.04-.65-.13zm-2.79-3.49c.23.27.36.7.34 1.05l-.06 1.05.98-.39a1.6 1.6 0 0 1 1.1 0l.98.39-.06-1.05c-.02-.35.11-.77.34-1.05l.67-.81-1.02-.26c-.34-.09-.7-.35-.89-.64l-.56-.88-.57.88c-.19.3-.55.56-.89.65l-1.03.25.67.81z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineAward);
export default __webpack_public_path__ + "static/media/vuesax-outline-award.d9feef6f8f0f34a97d9a7eaae0d622dc.svg";
export { ForwardRef as ReactComponent };